// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUYING_GUIDES_SHOW_LESS = "Zobraz m\u00e9n\u011b pr\u016fvodce";
export const BUYING_GUIDES_SHOW_MORE_count = "Zobraz dal\u0161\u00ed pr\u016fvodce (%(count)s)";
export const STROLLERS_BUYING_GUIDES_HEADER = "Modr\u00fd kon\u00edk t\u011b provede sv\u011btem ko\u010d\u00e1rk\u016f";
